import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
// import { KeypadSubmitResponse, KeypadTrapService } from "../services/KeypadTrapService";

const styles: string = css`
  .keypad { 
    background: #222; color: #fff;
    border: 2px solid #52478b; border-radius: 12px; padding: 20px;
  }
  .lcd { 
    display: grid; grid-template-columns: repeat(4, 46px); gap: 10px; margin-bottom: 12px;
    background: linear-gradient(#68c060,#42a642);
    border: 2px solid #2a6b2a; border-radius: 6px; padding: 8px;
  }
  .lcd div { 
    width: 46px; height: 46px; display: grid; place-items: center;
    background: #333; border: 1px solid #555; border-radius: 6px; font-weight: 700;
  }
  .pad { display: grid; grid-template-columns: repeat(3, 64px); gap: 10px; }
  button { height: 64px; border-radius: 8px; border: 1px solid #555; background: #444; color: #fff; cursor: pointer; }
  button:hover { background:#666; }
  button:disabled { opacity:.4; cursor:not-allowed; }
`;

export class MiniGameComponent extends HTMLElement {
    private _bus = new GameEventService();

    /** The last confirmed 4-bit code, e.g. "1010" */
    public result: string | null = null;

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
      <style>${styles}</style>
      <div class="keypad">
        <div class="lcd">
          <div>·</div><div>·</div><div>·</div><div>·</div>
        </div>
        <div class="pad">
          <button>0</button>
          <button>1</button>
          <button>X</button>
          <button>&lt;</button>
          <button>OK</button>
        </div>
      </div>
    `;

        this.setupKeypad();
    }

    private setupKeypad(): void {
        const lcd: NodeListOf<HTMLDivElement> = this.shadowRoot!.querySelectorAll<HTMLDivElement>(".lcd div");
        let currentKey: number = 0;

        const buttons: HTMLButtonElement[] = Array.from(this.shadowRoot!.querySelectorAll<HTMLButtonElement>("button"));

        const disableAllExceptX: () => void = () => {
            buttons.forEach(b => {
                if (b.textContent !== "X") {
                    b.disabled = true;
                }
            });
        };

        buttons.forEach(btn => {
            btn.addEventListener("click", () => {
                const key: string = btn.textContent!;

                if (key === "X") {
                    // Leave the keypad: go back to canvas
                    this._bus.switchPage(Page.Canvas);
                    return;
                }

                if (key === "<") {
                    if (currentKey > 0) {
                        currentKey--;
                        lcd[currentKey].textContent = "·";
                    }
                    return;
                }

                if (key === "OK") {
                    if (currentKey === 4) {
                        const code: string = Array.from(lcd, d => d.textContent ?? "").join("");
                        this.result = code;

                        disableAllExceptX();

                        // ✅ Local-only check
                        const correctCodes: string[] = ["1100", "1010", "0101"];
                        const isCorrect: boolean = correctCodes.includes(code);

                        if (isCorrect) {
                            lcd[0].textContent = "O";
                            lcd[1].textContent = "K";
                            lcd[2].textContent = "✓";
                            lcd[3].textContent = "✓";
                            setTimeout(() => this._bus.switchPage(Page.Canvas), 900);
                        }
                        else {
                            lcd[0].textContent = "F";
                            lcd[1].textContent = "O";
                            lcd[2].textContent = "U";
                            lcd[3].textContent = "T";
                        }
                    }
                    return;
                }

                // Only accept 0/1 and max length 4
                if ((key === "0" || key === "1") && currentKey < 4) {
                    lcd[currentKey].textContent = key;
                    currentKey++;
                }
            });
        });
    }
}

// customElements.define("game-minigame", MiniGameComponent);
